module.exports = __webpack_public_path__ + "static/media/background-music.af3c5311.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/background-music.mp3
// module id = 1379
// module chunks = 1